import { InvitationDto, useAcceptInvitation } from '@/gen/publicApi'

import { Button } from '@/components/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/card'
import { useToast } from '@/components/toast/useToast'

import { useSetClientCode } from '@/state/clientCode'

interface Props {
    token: string
    invite: InvitationDto
}

export default function AcceptForm({ invite, token }: Props) {
    const setClientCode = useSetClientCode()
    const { toast } = useToast()
    const acceptMutator = useAcceptInvitation(token)

    const onClick = () => {
        // @ts-expect-error - kubb codegen
        acceptMutator.mutate(undefined, {
            onSuccess: async () => {
                setClientCode(invite.clientCode)
                // Hard redirect to avoid client identity cache issues
                window.location.href = `/${invite.clientCode}`
            },
            onError: error => {
                console.error('Error accepting invite', error)
                toast({
                    variant: 'destructive',
                    title: 'Invitation acceptance failed!',
                    description: `Could not accept invitation, please try again`,
                })
            },
        })
    }

    return (
        <Card className="absolute-center w-96">
            <CardHeader>
                <CardTitle>Accept invitation</CardTitle>
            </CardHeader>
            <CardContent>
                <CardDescription>
                    <span className="mb-4 block">
                        🎉 You've been invited to join {invite.clientName} by {invite.inviterName}, how exciting!
                    </span>
                    <span>Do you want to accept this invitation?</span>
                </CardDescription>
                <Button className="mt-4" onClick={onClick} disabled={acceptMutator.isPending}>
                    Accept and join {invite.clientName}
                </Button>
            </CardContent>
        </Card>
    )
}
